module.exports = __webpack_public_path__ + "img/SVG10_NextSteps.4f7828aa.svg";